import './custom-styles.css';

export function EnvelopeCover() {
    return (
        <div className="envelope">
            <div className="envelope-flap">
                <div className="envelope-stamp">
                    <span>I | N</span>
                </div>
            </div>
            <div className="envelope-folds">
                <div className="envelope-left"></div>
                <div className="envelope-right"></div>
                <div className="envelope-bottom"></div>
            </div>
        </div>
    );
};